import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoaderService {
  private status = new BehaviorSubject<boolean>(false);

  status$ = this.status.asObservable();

  show(b: boolean = true) {
    if (b) {
      this.status.next(true);
    } else {
      this.hide();
    }
  }

  hide() {
    this.status.next(false);
  }
}
